import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const CTAHeader = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData = labels.menuPages?.buyCar?.ctaSection?.header || {};

  return (
    <div className="text-center mb-12 md:mb-16">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6">
        {headerData.title || "Därför Fungerar Vårt System Bättre"}
      </h2>
      <p className="text-gray-300 max-w-3xl mx-auto text-base md:text-lg px-4">
        {headerData.description ||
          "Jämför med traditionella metoder och se varför allt fler väljer auktionsmodellen."}
      </p>
    </div>
  );
};

export default CTAHeader;
